import useAgentData from '~/client/hooks/useAgentData';
import ToggleDesktop from './ToggleDesktop';
import ToggleMobile from './ToggleMobile';
import useToggle from './useToggle';

type Props = {
  showTooltip: (messageId: string) => void;
};

const Toggle: FC<Props> = ({ showTooltip }) => {
  const { isDesktop } = useAgentData();
  const { total, isLiked, handleClick } = useToggle({ showTooltip });

  if (isDesktop) {
    return (
      <ToggleDesktop total={total} isLiked={isLiked} onClick={handleClick} />
    );
  }
  return <ToggleMobile total={total} isLiked={isLiked} onClick={handleClick} />;
};

export default Toggle;
